module.exports = __webpack_public_path__ + "static/media/icon-crypto.7ba21db2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-crypto.svg
// module id = 1012
// module chunks = 0